import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

window.tippy  = tippy;
/* Format price */
window.formatPrice = (input, format = true) => {
  // Remove any existing commas and non-numeric characters
  const cleanValue = input.value.replace(/[^0-9.]/g, '');
  if (cleanValue == '') {
    input.value = null;
    return;
  }
  // Format the clean value with commas
  const formattedValue = format ? new Intl.NumberFormat('en-US').format(cleanValue) : cleanValue;
  // Set the input value to the formatted value
  input.value = formattedValue != 0 ? formattedValue : '';

}

window.totalPlan = function totalPlan() {
  var during_construction = $('#during_construction').val() ?? 0;
  var post_completion = $('#post_completion').val() ?? 0;
  var on_completion = $('#on_completion').val() ?? 0;
  var _total = (parseInt(during_construction) + parseInt(post_completion ? post_completion : 0) + parseInt(on_completion ? on_completion : 0));
  $('#sum_plan').val(_total);
}
var paymentTotal = 0;


window.duringConstruction = (obj, isInit = false) => {  // add isInit param
  if (!obj) return; // element doesn't exist on this page
  onDays = 101 - parseInt(obj.value)
  let on_completion = document.querySelector('#on_completion');
  document.querySelectorAll("#on_completion option").forEach(opt => {
    opt.disabled = opt.value >= onDays;
  });
  totalPlan();
  if (obj.value < 100 && obj.value >= 0) {
    $('#on_completion').parent().removeClass('disabled');
    $('#on_completion').attr('required');
  } else {
    $('#post_completion').parent().parent().addClass('disabled');
    $('#on_completion').parent().addClass('disabled');
    $('#post_completion_month').parent().addClass('disabled');
  }

  if (!isInit) {  // only reset dependents when user changes value
    $('#post_completion').val('').trigger('change');
    $('#on_completion').val('').trigger('change');
    $('#post_completion_month').val('').trigger('change');
  }
}



window.onCompletion = (obj) => {
  totalPlan();
  let during_construction = document.querySelector('#during_construction');
  let sum = 101 - (parseInt(during_construction.value) + parseInt(obj.value));
  document.querySelectorAll("#post_completion option").forEach(opt => {
    opt.disabled = opt.value >= (sum);
  });
  if (obj.value < 100 && obj.value > 0 && (sum - 1) > 0 && (parseInt(during_construction.value) + parseInt(obj.value)) < 100)
    $('#post_completion').parent().removeClass('disabled');
  else {
    $('#post_completion').val('').trigger('change');
    if ((parseInt(during_construction.value) + parseInt(obj.value)) == 100) {
      $('#post_completion').parent().addClass('disabled')
    } else {
      $('#post_completion').parent().removeClass('disabled');
    }
  }
}

window.onPostCompletion = (obj) => {
  totalPlan();
  postDays = onDays - obj.value;
  // console.log(obj.value, 'obj.value');
  if (obj.value > 0)
    $('#post_completion_month').parent().removeClass('disabled');
  else {

    $('#post_completion_month').parent().addClass('disabled').val(0).trigger('change');
    $('#post_completion_month').val('').trigger('change');
  }
}

if($('#during_construction').length){
  // Wire up Select2-safe change events
  $('#during_construction').on('change.select2', function () {
    duringConstruction(this); // user-driven, resets dependents
  });
  $('#on_completion').on('change.select2', function () {
    onCompletion(this);
  });
  $('#post_completion').on('change.select2', function () {
    onPostCompletion(this);
  });
}

// Seed sum_plan on page load without resetting saved values
duringConstruction(document.getElementById('during_construction'), true); // isInit = true
totalPlan(); // recalculate sum with all three saved values

window.managePlot = (type) => {
  if (type == 'Plot') {
    // Disable
    $('#project_min_beds').prop('required', false).parent().addClass('disabled')
    $('#project_max_beds').prop('required', false).parent().addClass('disabled')
    $('#project_min_beds').val('').trigger('change');
    $('#project_max_beds').val('').trigger('change');
  } else {
    $('#project_min_beds').prop('required', true).parent().removeClass('disabled')
    $('#project_max_beds').prop('required', true).parent().removeClass('disabled')
  }
}


/* Date picker for edit project page */
if ($('#construction_finish').length) {
  var startDate = moment().subtract(5, 'years').format('DD/MM/YYYY'); // Get the start date (current date - 29 days)
  var endDate = moment().add(7, 'years').format('DD/MM/YYYY'); // Get the current date
  $('#construction_finish').daterangepicker({
    "singleDatePicker": true,
    "autoApply": true,
    "opens": "left",
    "minDate": startDate,
    "maxDate": endDate,
    'showDropdowns': true,
    "drops": "auto",
    locale: {
      format: 'DD/MM/YYYY'
    },
  }, function (start, end, label) {
    console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
  });
}
if ($('#date_of_expiration').length) {
  $('#date_of_expiration').daterangepicker({
    "singleDatePicker": true,
    "autoUpdateInput": false,
    "autoApply": true,
    "opens": "left",
    'showDropdowns': true,
    "drops": "auto",
    'locale': {
      format: 'DD/MM/YYYY'
    },
  }, function (start) {
    // picker.element.val(picker.startDate.format(picker.locale.format));
    console.log('New date range selected: ' + start.format('DD/MM/YYYY'));
  });
  $('#date_of_expiration').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });
}


if ($('#banner_start_date').length) {
  $('#banner_start_date').daterangepicker({
    "singleDatePicker": true,
    "autoUpdateInput": false,
    "autoApply": true,
    "opens": "left",
    'showDropdowns': true,
    "drops": "auto",
    'locale': {
      format: 'DD/MM/YYYY'
    },
  }, function (start) {
    // picker.element.val(picker.startDate.format(picker.locale.format));
    //console.log('New date range selected: ' + start.format('DD/MM/YYYY'));
  });
  $('#banner_start_date').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });
}

if ($('#banner_end_date').length) {
  $('#banner_end_date').daterangepicker({
    "singleDatePicker": true,
    "autoUpdateInput": false,
    "autoApply": true,
    "opens": "left",
    'showDropdowns': true,
    "drops": "auto",
    'locale': {
      format: 'DD/MM/YYYY'
    },
  }, function (start) {
    // picker.element.val(picker.startDate.format(picker.locale.format));
    //console.log('New date range selected: ' + start.format('DD/MM/YYYY'));
  });
  $('#banner_end_date').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });
}


if ($('#contract_period').length) {
  $('#contract_period').daterangepicker({
    "singleDatePicker": true,
    "autoApply": true,
    "opens": "left",
    'showDropdowns': true,
    "drops": "auto",
  }, function (start, end, label) {
    console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
  });

}

document.addEventListener('DOMContentLoaded', function () {
  if ($('[data-tippy-content]').length) {
    tippy('[data-tippy-content]', {
      placement: $(this).data('tippy-placement') ? $(this).data('tippy-placement') : 'auto',
      allowHTML: true,

      trigger: $(this).data('tippy-trigger') ? $(this).data('tippy-trigger') : 'mouseenter focus',
      onTrigger(instance, event) {
        instance.unmount();
        instance.setContent("<span class='text-xsl'>" + event?.target?.dataset?.tippyContent + "</span>");
      }
    });
  }
});

window.reGenerateTippy = () => {
  const tippyInstances = tippy('[data-tippy-content]', {
    placement: 'auto',
    allowHTML: true,
    onTrigger(instance, event) {
      instance.unmount();
      if (event?.target?.dataset?.tippyContent) {
        instance.setContent("<span class='text-xsl'>" + event?.target?.dataset?.tippyContent + "</span>");
      } else {
        instance.disable()
      }
    }
  });
}

window.copyToClipboard = (element) => {
  var $temp = $("<input>");
  $("body").append($temp);
  var textToCopy = $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
  window.Livewire.emit('alert', { html: true, type: false, 'message': "<p class='text-xs'>Copied to clipboard: " + $(element).text() + "</p>" })
}

// Function to store unique IDs, check for new/existing IDs, and reset after 24 hours
window.manageBuyPagePropertyIds = (newArrays, storageKey = 'home_page_properties', timestampKey = 'home_page_properties_timestamp') => {

  // Get existing IDs and timestamp from localStorage
  const storedData = JSON.parse(localStorage.getItem(storageKey)) || [];
  const storedTimestamp = parseInt(localStorage.getItem(timestampKey), 10);

  // Flatten new arrays and deduplicate them
  const newIds = Array.from(new Set(newArrays.flat()));

  // Check if 24 hours have passed since the last update
  const now = Date.now();
  if (storedTimestamp && now - storedTimestamp > 86400000) { // 24 hours in ms
    // If 24 hours passed, reset stored data and update the timestamp
    localStorage.setItem(storageKey, JSON.stringify(newIds));
    localStorage.setItem(timestampKey, now);
    // console.log("24 hours have passed. Data has been reset.");
    // console.log("Newly added IDs:", newIds);
    return {
      "Newly_Added_IDs": [],
      "Already_Existing_IDs": []
    }
  } else if (!storedTimestamp) {
    // Set timestamp if not present
    localStorage.setItem(timestampKey, now);
  }

  // Convert existing stored IDs to a Set for easy comparison
  const storedIdSet = new Set(storedData);

  // Identify which IDs are new or already exist
  const idsToAdd = newIds.filter(id => !storedIdSet.has(id));
  const existingIds = newIds.filter(id => storedIdSet.has(id));

  // Update localStorage with unique combined IDs
  const updatedIds = Array.from(new Set([...storedData, ...idsToAdd]));
  localStorage.setItem(storageKey, JSON.stringify(updatedIds));

  // Output for tracking
  // console.log("Newly added IDs:", idsToAdd);
  // console.log("Already existing IDs:", existingIds);
  return {
    "Newly_Added_IDs": idsToAdd,
    "Already_Existing_IDs": existingIds
  }
}

window.encodeSVG = (rawSvgString) => {
  const symbols = /[\r\n%#()<>?\[\\\]^`{|}]/g;
  // Use single quotes instead of double to avoid URI encoding
  rawSvgString = rawSvgString.replace(/'/g, '"').replace(/>\s+</g, '><').replace(/\s{2,}/g, ' ');
  return 'data:image/svg+xml;utf-8,' + rawSvgString.replace(symbols, encodeURIComponent);
}

window.tagSvgRaw = (price, project_name, property_count) => {
  let count_length1 = property_count?.toString()?.length;
  var count1;
  if (count_length1 > 1) {
    count1 = `<tspan x="0" y="0">${property_count}</tspan>`;
  } else {
    count1 = `<tspan x="4" y="0">${property_count}</tspan>`;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="195.973" height="57.551" viewBox="0 0 195.973 57.551">
  <defs>
    <filter id="Rectangle_10683" x="7.461" y="0" width="188.512" height="57.551" filterUnits="userSpaceOnUse">
      <feOffset dy="3" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur"/>
      <feFlood flood-opacity="0.102"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Path_10406" x="0" y="20.646" width="35.469" height="32.91" filterUnits="userSpaceOnUse">
      <feOffset dx="1" dy="1" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur-2"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur-2"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Group_20406" data-name="Group 20406" transform="translate(9405.461 20150.365)">
    <g transform="matrix(1, 0, 0, 1, -9405.46, -20150.37)" filter="url(#Rectangle_10683)">
      <path id="Rectangle_10683-2" data-name="Rectangle 10683" d="M0,0H164.512a6,6,0,0,1,6,6V33.55a6,6,0,0,1-6,6H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z" transform="translate(16.46 6)" fill="#fff"/>
    </g>
    <text id="AED_1.2_M_to_4.5M" data-name="AED 1.2 M to 4.5M" transform="translate(-9346 -20112.385)" fill="#2d2b2b" font-size="10" font-family="Helvetica"><tspan x="0" y="0">${price}</tspan></text>
    <text id="Caya" transform="translate(-9296 -20129.365)" fill="#2d2b2b" font-size="14" font-family="Helvetica">
        <tspan x="-52.365" y="0">${project_name}</tspan>
    </text>
    <g id="Group_20404" data-name="Group 20404" transform="translate(-9402.3 -20145.199)">
      <g transform="matrix(1, 0, 0, 1, -3.16, -5.17)" filter="url(#Path_10406)">
        <path id="Path_10406-2" data-name="Path 10406" d="M-8709.464-16098.444l-8.445,14.91-9.023-14.91Z" transform="translate(8734.93 16127.09)" fill="#ecebeb"/>
      </g>
      <g id="Group_12302" data-name="Group 12302" transform="translate(0.001 0)">
        <g id="Group_12161" data-name="Group 12161">
          <g id="Group_11695" data-name="Group 11695">
            <g id="Group_11694" data-name="Group 11694">
              <path id="Path_10183" data-name="Path 10183" d="M232.442,901.009A13.464,13.464,0,0,0,220.6,920.869l11.11,20.092a.841.841,0,0,0,1.472,0l11.114-20.1a13.464,13.464,0,0,0-11.85-19.852Zm0,20.193a6.731,6.731,0,1,1,6.731-6.731A6.739,6.739,0,0,1,232.442,921.2Z" transform="translate(-218.98 -901.009)" fill="#bfed32"/>
            </g>
          </g>
          <path id="Path_10399" data-name="Path 10399" d="M11.111,0A11.111,11.111,0,1,1,0,11.111,11.111,11.111,0,0,1,11.111,0Z" transform="translate(2.351 2.421)" fill="#fff"/>
        </g>
        <text id="_25" data-name="25" transform="translate(6.299 17.2)" fill="#060606" font-size="13" font-family="SegoeUI, Segoe UI">${count1}</text>
      </g>
    </g>
  </g>
</svg>
`;
};
window.clickMarkerSVG = (price, project_name, property_count) => {
  let count_length1 = property_count?.toString()?.length;
  var count1;
  if (count_length1 > 1) {
    count1 = `<tspan x="0" y="0">${property_count}</tspan>`;
  } else {
    count1 = `<tspan x="4" y="0">${property_count}</tspan>`;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="195.973" height="57.551" viewBox="0 0 195.973 57.551">
  <defs>
    <filter id="Rectangle_7574" x="7.461" y="0" width="188.512" height="57.551" filterUnits="userSpaceOnUse">
      <feOffset dy="3" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur"/>
      <feFlood flood-opacity="0.102"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Path_10406" x="0" y="20.646" width="35.469" height="32.91" filterUnits="userSpaceOnUse">
      <feOffset dx="1" dy="1" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur-2"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur-2"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Group_20405" data-name="Group 20405" transform="translate(9608.461 20150.365)">
    <g transform="matrix(1, 0, 0, 1, -9608.46, -20150.37)" filter="url(#Rectangle_7574)">
      <path id="Rectangle_7574-2" data-name="Rectangle 7574" d="M0,0H164.512a6,6,0,0,1,6,6V33.55a6,6,0,0,1-6,6H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z" transform="translate(16.46 6)" fill="#3d3ce2"/>
    </g>
    <text id="AED_1.2_M_to_4.5M" data-name="AED 1.2 M to 4.5M" transform="translate(-9548.582 -20112.385)" fill="#fff" font-size="10" font-family="Helvetica"><tspan x="0" y="0">${price}</tspan></text>
    <text id="Caya" transform="translate(-9500.375 -20129.365)" fill="#fff" font-size="14" font-family="Helvetica"><tspan x="-52.365" y="0">${project_name}</tspan></text>
    <g id="Group_12303" data-name="Group 12303" transform="translate(-9605.3 -20145.199)">
      <g transform="matrix(1, 0, 0, 1, -3.16, -5.17)" filter="url(#Path_10406)">
        <path id="Path_10406-2" data-name="Path 10406" d="M-8709.464-16098.444l-8.445,14.91-9.023-14.91Z" transform="translate(8734.93 16127.09)" fill="#ecebeb"/>
      </g>
      <g id="Group_12302" data-name="Group 12302" transform="translate(0.001 0)">
        <g id="Group_12161" data-name="Group 12161">
          <g id="Group_11695" data-name="Group 11695">
            <g id="Group_11694" data-name="Group 11694">
              <path id="Path_10183" data-name="Path 10183" d="M232.442,901.009A13.464,13.464,0,0,0,220.6,920.869l11.11,20.092a.841.841,0,0,0,1.472,0l11.114-20.1a13.464,13.464,0,0,0-11.85-19.852Zm0,20.193a6.731,6.731,0,1,1,6.731-6.731A6.739,6.739,0,0,1,232.442,921.2Z" transform="translate(-218.98 -901.009)" fill="#bfed32"/>
            </g>
          </g>
          <path id="Path_10399" data-name="Path 10399" d="M11.111,0A11.111,11.111,0,1,1,0,11.111,11.111,11.111,0,0,1,11.111,0Z" transform="translate(2.351 2.421)" fill="#fff"/>
        </g>
        <text id="_25" data-name="25" transform="translate(6.299 17.2)" fill="#060606" font-size="13" font-family="SegoeUI, Segoe UI">${count1}</text>
      </g>
    </g>
  </g>
</svg>
`;
};

window.getQueryStrings = (key = null) => {
  const query = window.location.search;
  const params = new URLSearchParams(query);
  if (key) {
    return params.getAll(key); // when get only
  }
  return Object.fromEntries(params.entries()); // all parameters
}

window.toQueryStringForOtherLocations = (arr, keyName = "data") => {

  return {
    [keyName]: arr.map((item, index) => ({
      id: index + 1,
      text: item
    }))
  };

};

window.onImageError = (event) => {
  return event.src = '/images/placeholder.png';
}

window.getOrdinalSuffix = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

window.currencyFormat = (value, currency = 'AED') => {
  if (!currency) {
    // Format the number with commas
    const formattedValue = value
      .toFixed(2) // Ensure two decimal places (optional)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas

    // Prepend 'AED' and return the result
    return `${formattedValue}`;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(value);
}

window.redirectToWhatsapp = async (property) => {
  await Livewire.emit('WhatsAppClicked', property?.id);
  const link = property.whatsapp_inquiry_text;
  setTimeout(() => {
    // Open WhatsApp in a new tab
    const newTab = window.open(link, '_blank');
    // Fallback if popup is blocked
    if (!newTab) {
      window.location.href = whatsappUrl; // force redirect
    }
  }, 0);
};
window.imagePreview = (inputId, previewId) => {

  const input = document.getElementById(inputId);
  const preview = document.getElementById(previewId);

  if (!input) return;

  input.addEventListener("change", function () {

    const file = this.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = function (e) {
      preview.src = e.target.result;
      preview.classList.remove("hidden");
      console.log(preview.classList, 'preview.classList');

    };

    reader.readAsDataURL(file);

  });
}

window.validateByField = (formId, fieldName) => {
  if($(formId).length > 0){
    $(formId)
      .validate()
      .element('[name="' + fieldName + '"]')
  }
}
window.isButtonsVisible = (property, $dashboard = false) => {

  const global = window.global;
  if (!property) {
    return false;
  }

  // if (global.isAgent) {
    return parseInt(global.user_id) != property.owned_by_user_id;
  // }
  // if (!global.isAgent) {
  //   return ((property.developer_id != global.developer_id) || $dashboard);
  // }
  return true;
}